module.exports = __webpack_public_path__ + "static/media/cancel.c139061e.png";